import {RemoteGetContractualTermLink} from 'data/usecases/private/home/remote-get-contractual-term-link';
import {GetContractualTermLink} from 'domain/usecases/private/home/get-contractual-term-link';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {HomeEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetContractualTermLink = (): GetContractualTermLink =>
	new RemoteGetContractualTermLink(
		makeBFFApiUrl(HomeEndPoints.contractualTermLojasTorra),
		makeAuthorizeHttpClientDecorator(),
	);
